module.exports = {
  elements: [
    {
      name: 'None',
      summary: 'Place of zero so that the array starts with 1 with hydrogen',
    },
    {
      name: '1',
      appearance: 'colorless gas',
      atomic_mass: 1.008,
      boil: 20.271,
      category: 'green_state',
      color: null,
      density: 0.08988,
      discovered_by: 'Henry Cavendish',
      melt: 13.99,
      molar_heat: 28.836,
      named_by: 'Antoine Lavoisier',
      number: 1,
      period: 1,
      phase: 'Gas',
      source: 'https://en.wikipedia.org/wiki/Hydrogen',
      spectral_img: 'https://en.wikipedia.org/wiki/File:Hydrogen_Spectra.jpg',
      summary:
        'Hydrogen is a chemical element with chemical symbol H and atomic number 1. With an atomic weight of 1.00794 u, hydrogen is the lightest element on the periodic table. Its monatomic form (H) is the most abundant chemical substance in the Universe, constituting roughly 75% of all baryonic mass.',
      symbol: '1',
      xpos: 1,
      ypos: 1,
      shells: [1],
    },
    {
      name: '2',
      appearance: 'colorless gas, exhibiting a red-orange glow when placed in a high-voltage electric field',
      atomic_mass: 4.0026022,
      boil: 4.222,
      category: 'green_state',
      color: null,
      density: 0.1786,
      discovered_by: 'Pierre Janssen',
      melt: 0.95,
      molar_heat: null,
      named_by: null,
      number: 2,
      period: 1,
      phase: 'Gas',
      source: 'https://en.wikipedia.org/wiki/Helium',
      spectral_img: 'https://en.wikipedia.org/wiki/File:Helium_spectrum.jpg',
      summary:
        'Helium is a chemical element with symbol He and atomic number 2. It is a colorless, odorless, tasteless, non-toxic, inert, monatomic gas that heads the noble gas group in the periodic table. Its boiling and melting points are the lowest among all the elements.',
      symbol: '2',
      xpos: 18,
      ypos: 1,
      shells: [2],
    },
    {
      name: '3',
      appearance: 'silvery-white',
      atomic_mass: 6.94,
      boil: 1603,
      category: 'yellow_state',
      color: null,
      density: 0.534,
      discovered_by: 'Johan August Arfwedson',
      melt: 453.65,
      molar_heat: 24.86,
      named_by: null,
      number: 3,
      period: 2,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Lithium',
      spectral_img: null,
      summary:
        'Lithium (from Greek:\u03bb\u03af\u03b8\u03bf\u03c2 lithos, "stone") is a chemical element with the symbol Li and atomic number 3. It is a soft, silver-white metal belonging to the alkali metal group of chemical elements. Under standard conditions it is the lightest metal and the least dense solid element.',
      symbol: '3',
      xpos: 1,
      ypos: 2,
      shells: [2, 1],
    },
    {
      name: '4',
      appearance: 'white-gray metallic',
      atomic_mass: 9.01218315,
      boil: 2742,
      category: 'red_state',
      color: null,
      density: 1.85,
      discovered_by: 'Louis Nicolas Vauquelin',
      melt: 1560,
      molar_heat: 16.443,
      named_by: null,
      number: 4,
      period: 2,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Beryllium',
      spectral_img: null,
      summary:
        'Beryllium is a chemical element with symbol Be and atomic number 4. It is created through stellar nucleosynthesis and is a relatively rare element in the universe. It is a divalent element which occurs naturally only in combination with other elements in minerals.',
      symbol: '4',
      xpos: 2,
      ypos: 2,
      shells: [2, 2],
    },
    {
      name: '5',
      appearance: 'black-brown',
      atomic_mass: 10.81,
      boil: 4200,
      category: 'green_state',
      color: null,
      density: 2.08,
      discovered_by: 'Joseph Louis Gay-Lussac',
      melt: 2349,
      molar_heat: 11.087,
      named_by: null,
      number: 5,
      period: 2,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Boron',
      spectral_img: null,
      summary:
        "Boron is a metalloid chemical element with symbol B and atomic number 5. Produced entirely by cosmic ray spallation and supernovae and not by stellar nucleosynthesis, it is a low-abundance element in both the Solar system and the Earth's crust. Boron is concentrated on Earth by the water-solubility of its more common naturally occurring compounds, the borate minerals.",
      symbol: '5',
      xpos: 13,
      ypos: 2,
      shells: [2, 3],
    },
    {
      name: '6',
      appearance: null,
      atomic_mass: 12.011,
      boil: null,
      category: 'green_state',
      color: null,
      density: 1.821,
      discovered_by: 'Ancient Egypt',
      melt: null,
      molar_heat: 8.517,
      named_by: null,
      number: 6,
      period: 2,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Carbon',
      spectral_img: 'https://en.wikipedia.org/wiki/File:Carbon_Spectra.jpg',
      summary:
        'Carbon (from Latin:carbo "coal") is a chemical element with symbol C and atomic number 6. On the periodic table, it is the first (row 2) of six elements in column (group) 14, which have in common the composition of their outer electron shell. It is nonmetallic and tetravalent\u2014making four electrons available to form covalent chemical bonds.',
      symbol: '6',
      xpos: 14,
      ypos: 2,
      shells: [2, 4],
    },
    {
      name: '7',
      appearance: 'colorless gas, liquid or solid',
      atomic_mass: 14.007,
      boil: 77.355,
      category: 'red_state',
      color: null,
      density: 1.251,
      discovered_by: 'Daniel Rutherford',
      melt: 63.15,
      molar_heat: null,
      named_by: 'Jean-Antoine Chaptal',
      number: 7,
      period: 2,
      phase: 'Gas',
      source: 'https://en.wikipedia.org/wiki/Nitrogen',
      spectral_img: 'https://en.wikipedia.org/wiki/File:Nitrogen_Spectra.jpg',
      summary:
        'Nitrogen is a chemical element with symbol N and atomic number 7. It is the lightest pnictogen and at room temperature, it is a transparent, odorless diatomic gas. Nitrogen is a common element in the universe, estimated at about seventh in total abundance in the Milky Way and the Solar System.',
      symbol: '7',
      xpos: 15,
      ypos: 2,
      shells: [2, 5],
    },
    {
      name: '8',
      appearance: null,
      atomic_mass: 15.999,
      boil: 90.188,
      category: 'emtpy_state',
      color: null,
      density: 1.429,
      discovered_by: 'Carl Wilhelm Scheele',
      melt: 54.36,
      molar_heat: null,
      named_by: 'Antoine Lavoisier',
      number: 8,
      period: 2,
      phase: 'Gas',
      source: 'https://en.wikipedia.org/wiki/Oxygen',
      spectral_img: 'https://en.wikipedia.org/wiki/File:Oxygen_spectre.jpg',
      summary:
        'Oxygen is a chemical element with symbol O and atomic number 8. It is a member of the chalcogen group on the periodic table and is a highly reactive nonmetal and oxidizing agent that readily forms compounds (notably oxides) with most elements. By mass, oxygen is the third-most abundant element in the universe, after hydrogen and helium.',
      symbol: '8',
      xpos: 16,
      ypos: 2,
      shells: [2, 6],
    },
    {
      name: '9',
      appearance: null,
      atomic_mass: 18.9984031636,
      boil: 85.03,
      category: 'emtpy_state',
      color: null,
      density: 1.696,
      discovered_by: 'Andr\u00e9-Marie Amp\u00e8re',
      melt: 53.48,
      molar_heat: null,
      named_by: 'Humphry Davy',
      number: 9,
      period: 2,
      phase: 'Gas',
      source: 'https://en.wikipedia.org/wiki/Fluorine',
      spectral_img: null,
      summary:
        'Fluorine is a chemical element with symbol F and atomic number 9. It is the lightest halogen and exists as a highly toxic pale yellow diatomic gas at standard conditions. As the most electronegative element, it is extremely reactive:almost all other elements, including some noble gases, form compounds with fluorine.',
      symbol: '9',
      xpos: 17,
      ypos: 2,
      shells: [2, 7],
    },
    {
      name: '10',
      appearance: 'colorless gas exhibiting an orange-red glow when placed in a high voltage electric field',
      atomic_mass: 20.17976,
      boil: 27.104,
      category: 'emtpy_state',
      color: null,
      density: 0.9002,
      discovered_by: 'Morris Travers',
      melt: 24.56,
      molar_heat: null,
      named_by: null,
      number: 10,
      period: 2,
      phase: 'Gas',
      source: 'https://en.wikipedia.org/wiki/Neon',
      spectral_img: 'https://en.wikipedia.org/wiki/File:Neon_spectra.jpg',
      summary:
        'Neon is a chemical element with symbol Ne and atomic number 10. It is in group 18 (noble gases) of the periodic table. Neon is a colorless, odorless, inert monatomic gas under standard conditions, with about two-thirds the density of air.',
      symbol: '10',
      xpos: 18,
      ypos: 2,
      shells: [2, 8],
    },
    {
      name: '11',
      appearance: 'silvery white metallic',
      atomic_mass: 22.989769282,
      boil: 1156.09,
      category: 'emtpy_state',
      color: null,
      density: 0.968,
      discovered_by: 'Humphry Davy',
      melt: 370.944,
      molar_heat: 28.23,
      named_by: null,
      number: 11,
      period: 3,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Sodium',
      spectral_img: 'https://en.wikipedia.org/wiki/File:Sodium_Spectra.jpg',
      summary:
        'Sodium /\u02c8so\u028adi\u0259m/ is a chemical element with symbol Na (from Ancient Greek \u039d\u03ac\u03c4\u03c1\u03b9\u03bf) and atomic number 11. It is a soft, silver-white, highly reactive metal. In the Periodic table it is in column 1 (alkali metals), and shares with the other six elements in that column that it has a single electron in its outer shell, which it readily donates, creating a positively charged atom - a cation.',
      symbol: '11',
      xpos: 1,
      ypos: 3,
      shells: [2, 8, 1],
    },
    {
      name: '12',
      appearance: 'shiny grey solid',
      atomic_mass: 24.305,
      boil: 1363,
      category: 'emtpy_state',
      color: null,
      density: 1.738,
      discovered_by: 'Joseph Black',
      melt: 923,
      molar_heat: 24.869,
      named_by: null,
      number: 12,
      period: 3,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Magnesium',
      spectral_img: 'https://en.wikipedia.org/wiki/File:Magnesium_Spectra.jpg',
      summary:
        'Magnesium is a chemical element with symbol Mg and atomic number 12. It is a shiny gray solid which bears a close physical resemblance to the other five elements in the second column (Group 2, or alkaline earth metals) of the periodic table:they each have the same electron configuration in their outer electron shell producing a similar crystal structure. Magnesium is the ninth most abundant element in the universe.',
      symbol: '12',
      xpos: 2,
      ypos: 3,
      shells: [2, 8, 2],
    },
    {
      name: '13',
      appearance: 'silvery gray metallic',
      atomic_mass: 26.98153857,
      boil: 2743,
      category: 'emtpy_state',
      color: null,
      density: 2.7,
      discovered_by: null,
      melt: 933.47,
      molar_heat: 24.2,
      named_by: 'Humphry Davy',
      number: 13,
      period: 3,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Aluminium',
      spectral_img: null,
      summary:
        "Aluminium (or aluminum; see different endings) is a chemical element in the boron group with symbol Al and atomic number 13. It is a silvery-white, soft, nonmagnetic, ductile metal. Aluminium is the third most abundant element (after oxygen and silicon), and the most abundant metal, in the Earth's crust.",
      symbol: 'Al',
      xpos: 13,
      ypos: 3,
      shells: [2, 8, 3],
    },
    {
      name: '14',
      appearance: 'crystalline, reflective with bluish-tinged faces',
      atomic_mass: 28.085,
      boil: 3538,
      category: 'emtpy_state',
      color: null,
      density: 2.329,
      discovered_by: 'J\u00f6ns Jacob Berzelius',
      melt: 1687,
      molar_heat: 19.789,
      named_by: 'Thomas Thomson (chemist)',
      number: 14,
      period: 3,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Silicon',
      spectral_img: 'https://en.wikipedia.org/wiki/File:Silicon_Spectra.jpg',
      summary:
        "Silicon is a chemical element with symbol Si and atomic number 14. It is a tetravalent metalloid, more reactive than germanium, the metalloid directly below it in the table. Controversy about silicon's character dates to its discovery.",
      symbol: 'Si',
      xpos: 14,
      ypos: 3,
      shells: [2, 8, 4],
    },
    {
      name: '15',
      appearance: 'colourless, waxy white, yellow, scarlet, red, violet, black',
      atomic_mass: 30.9737619985,
      boil: null,
      category: 'emtpy_state',
      color: null,
      density: 1.823,
      discovered_by: 'Hennig Brand',
      melt: null,
      molar_heat: 23.824,
      named_by: null,
      number: 15,
      period: 3,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Phosphorus',
      spectral_img: null,
      summary:
        'Phosphorus is a chemical element with symbol P and atomic number 15. As an element, phosphorus exists in two major forms\u2014white phosphorus and red phosphorus\u2014but due to its high reactivity, phosphorus is never found as a free element on Earth. Instead phosphorus-containing minerals are almost always present in their maximally oxidised state, as inorganic phosphate rocks.',
      symbol: 'P',
      xpos: 15,
      ypos: 3,
      shells: [2, 8, 5],
    },
    {
      name: '16',
      appearance: 'lemon yellow sintered microcrystals',
      atomic_mass: 32.06,
      boil: 717.8,
      category: 'emtpy_state',
      color: null,
      density: 2.07,
      discovered_by: 'Ancient china',
      melt: 388.36,
      molar_heat: 22.75,
      named_by: null,
      number: 16,
      period: 3,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Sulfur',
      spectral_img: 'https://en.wikipedia.org/wiki/File:Sulfur_Spectrum.jpg',
      summary:
        'Sulfur or sulphur (see spelling differences) is a chemical element with symbol S and atomic number 16. It is an abundant, multivalent non-metal. Under normal conditions, sulfur atoms form cyclic octatomic molecules with chemical formula S8.',
      symbol: 'S',
      xpos: 16,
      ypos: 3,
      shells: [2, 8, 6],
    },
    {
      name: '17',
      appearance: 'pale yellow-green gas',
      atomic_mass: 35.45,
      boil: 239.11,
      category: 'emtpy_state',
      color: null,
      density: 3.2,
      discovered_by: 'Carl Wilhelm Scheele',
      melt: 171.6,
      molar_heat: null,
      named_by: null,
      number: 17,
      period: 3,
      phase: 'Gas',
      source: 'https://en.wikipedia.org/wiki/Chlorine',
      spectral_img: 'https://en.wikipedia.org/wiki/File:Chlorine_spectrum_visible.png',
      summary:
        'Chlorine is a chemical element with symbol Cl and atomic number 17. It also has a relative atomic mass of 35.5. Chlorine is in the halogen group (17) and is the second lightest halogen following fluorine.',
      symbol: 'Cl',
      xpos: 17,
      ypos: 3,
      shells: [2, 8, 7],
    },
    {
      name: '18',
      appearance: 'colorless gas exhibiting a lilac/violet glow when placed in a high voltage electric field',
      atomic_mass: 39.9481,
      boil: 87.302,
      category: 'emtpy_state',
      color: null,
      density: 1.784,
      discovered_by: 'Lord Rayleigh',
      melt: 83.81,
      molar_heat: null,
      named_by: null,
      number: 18,
      period: 3,
      phase: 'Gas',
      source: 'https://en.wikipedia.org/wiki/Argon',
      spectral_img: 'https://en.wikipedia.org/wiki/File:Argon_Spectrum.png',
      summary:
        "Argon is a chemical element with symbol Ar and atomic number 18. It is in group 18 of the periodic table and is a noble gas. Argon is the third most common gas in the Earth's atmosphere, at 0.934% (9,340 ppmv), making it over twice as abundant as the next most common atmospheric gas, water vapor (which averages about 4000 ppmv, but varies greatly), and 23 times as abundant as the next most common non-condensing atmospheric gas, carbon dioxide (400 ppmv), and more than 500 times as abundant as the next most common noble gas, neon (18 ppmv).",
      symbol: 'Ar',
      xpos: 18,
      ypos: 3,
      shells: [2, 8, 8],
    },
    {
      name: '19',
      appearance: 'silvery gray',
      atomic_mass: 39.09831,
      boil: 1032,
      category: 'emtpy_state',
      color: null,
      density: 0.862,
      discovered_by: 'Humphry Davy',
      melt: 336.7,
      molar_heat: 29.6,
      named_by: null,
      number: 19,
      period: 4,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Potassium',
      spectral_img: 'https://en.wikipedia.org/wiki/File:Potassium_Spectrum.jpg',
      summary:
        'Potassium is a chemical element with symbol K (derived from Neo-Latin, kalium) and atomic number 19. It was first isolated from potash, the ashes of plants, from which its name is derived. In the Periodic table, potassium is one of seven elements in column (group) 1 (alkali metals):they all have a single valence electron in their outer electron shell, which they readily give up to create an atom with a positive charge - a cation, and combine with anions to form salts.',
      symbol: 'K',
      xpos: 1,
      ypos: 4,
      shells: [2, 8, 8, 1],
    },
    {
      name: '20',
      appearance: null,
      atomic_mass: 40.0784,
      boil: 1757,
      category: 'emtpy_state',
      color: null,
      density: 1.55,
      discovered_by: 'Humphry Davy',
      melt: 1115,
      molar_heat: 25.929,
      named_by: null,
      number: 20,
      period: 4,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Calcium',
      spectral_img: 'https://en.wikipedia.org/wiki/File:Calcium_Spectrum.png',
      summary:
        "Calcium is a chemical element with symbol Ca and atomic number 20. Calcium is a soft gray alkaline earth metal, fifth-most-abundant element by mass in the Earth's crust. The ion Ca2+ is also the fifth-most-abundant dissolved ion in seawater by both molarity and mass, after sodium, chloride, magnesium, and sulfate.",
      symbol: 'Ca',
      xpos: 2,
      ypos: 4,
      shells: [2, 8, 8, 2],
    },
    {
      name: '21',
      appearance: 'silvery white',
      atomic_mass: 44.9559085,
      boil: 3109,
      category: 'emtpy_state',
      color: null,
      density: 2.985,
      discovered_by: 'Lars Fredrik Nilson',
      melt: 1814,
      molar_heat: 25.52,
      named_by: null,
      number: 21,
      period: 4,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Scandium',
      spectral_img: null,
      summary:
        'Scandium is a chemical element with symbol Sc and atomic number 21. A silvery-white metallic d-block element, it has historically been sometimes classified as a rare earth element, together with yttrium and the lanthanoids. It was discovered in 1879 by spectral analysis of the minerals euxenite and gadolinite from Scandinavia.',
      symbol: 'Sc',
      xpos: 3,
      ypos: 4,
      shells: [2, 8, 9, 2],
    },
    {
      name: '22',
      appearance: 'silvery grey-white metallic',
      atomic_mass: 47.8671,
      boil: 3560,
      category: 'emtpy_state',
      color: null,
      density: 4.506,
      discovered_by: 'William Gregor',
      melt: 1941,
      molar_heat: 25.06,
      named_by: 'Martin Heinrich Klaproth',
      number: 22,
      period: 4,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Titanium',
      spectral_img: null,
      summary:
        'Titanium is a chemical element with symbol Ti and atomic number 22. It is a lustrous transition metal with a silver color, low density and high strength. It is highly resistant to corrosion in sea water, aqua regia and chlorine.',
      symbol: 'Ti',
      xpos: 4,
      ypos: 4,
      shells: [2, 8, 10, 2],
    },
    {
      name: '23',
      appearance: 'blue-silver-grey metal',
      atomic_mass: 50.94151,
      boil: 3680,
      category: 'emtpy_state',
      color: null,
      density: 6.0,
      discovered_by: 'Andr\u00e9s Manuel del R\u00edo',
      melt: 2183,
      molar_heat: 24.89,
      named_by: 'Isotopes of vanadium',
      number: 23,
      period: 4,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Vanadium',
      spectral_img: null,
      summary:
        'Vanadium is a chemical element with symbol V and atomic number 23. It is a hard, silvery grey, ductile and malleable transition metal. The element is found only in chemically combined form in nature, but once isolated artificially, the formation of an oxide layer stabilizes the free metal somewhat against further oxidation.',
      symbol: 'V',
      xpos: 5,
      ypos: 4,
      shells: [2, 8, 11, 2],
    },
    {
      name: '24',
      appearance: 'silvery metallic',
      atomic_mass: 51.99616,
      boil: 2944,
      category: 'emtpy_state',
      color: null,
      density: 7.19,
      discovered_by: 'Louis Nicolas Vauquelin',
      melt: 2180,
      molar_heat: 23.35,
      named_by: null,
      number: 24,
      period: 4,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Chromium',
      spectral_img: null,
      summary:
        'Chromium is a chemical element with symbol Cr and atomic number 24. It is the first element in Group 6. It is a steely-gray, lustrous, hard and brittle metal which takes a high polish, resists tarnishing, and has a high melting point.',
      symbol: 'Cr',
      xpos: 6,
      ypos: 4,
      shells: [2, 8, 13, 1],
    },
    {
      name: '25',
      appearance: 'silvery metallic',
      atomic_mass: 54.9380443,
      boil: 2334,
      category: 'emtpy_state',
      color: null,
      density: 7.21,
      discovered_by: 'Torbern Olof Bergman',
      melt: 1519,
      molar_heat: 26.32,
      named_by: null,
      number: 25,
      period: 4,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Manganese',
      spectral_img: null,
      summary:
        'Manganese is a chemical element with symbol Mn and atomic number 25. It is not found as a free element in nature; it is often found in combination with iron, and in many minerals. Manganese is a metal with important industrial metal alloy uses, particularly in stainless steels.',
      symbol: 'Mn',
      xpos: 7,
      ypos: 4,
      shells: [2, 8, 13, 2],
    },
    {
      name: '26',
      appearance: 'lustrous metallic with a grayish tinge',
      atomic_mass: 55.8452,
      boil: 3134,
      category: 'emtpy_state',
      color: null,
      density: 7.874,
      discovered_by: '5000 BC',
      melt: 1811,
      molar_heat: 25.1,
      named_by: null,
      number: 26,
      period: 4,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Iron',
      spectral_img: 'https://en.wikipedia.org/wiki/File:Iron_Spectrum.jpg',
      summary:
        "Iron is a chemical element with symbol Fe (from Latin:ferrum) and atomic number 26. It is a metal in the first transition series. It is by mass the most common element on Earth, forming much of Earth's outer and inner core.",
      symbol: 'Fe',
      xpos: 8,
      ypos: 4,
      shells: [2, 8, 14, 2],
    },
    {
      name: '27',
      appearance: 'hard lustrous gray metal',
      atomic_mass: 58.9331944,
      boil: 3200,
      category: 'emtpy_state',
      color: 'metallic gray',
      density: 8.9,
      discovered_by: 'Georg Brandt',
      melt: 1768,
      molar_heat: 24.81,
      named_by: null,
      number: 27,
      period: 4,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Cobalt',
      spectral_img: null,
      summary:
        "Cobalt is a chemical element with symbol Co and atomic number 27. Like nickel, cobalt in the Earth's crust is found only in chemically combined form, save for small deposits found in alloys of natural meteoric iron. The free element, produced by reductive smelting, is a hard, lustrous, silver-gray metal.",
      symbol: 'Co',
      xpos: 9,
      ypos: 4,
      shells: [2, 8, 15, 2],
    },
    {
      name: '28',
      appearance: 'lustrous, metallic, and silver with a gold tinge',
      atomic_mass: 58.69344,
      boil: 3003,
      category: 'emtpy_state',
      color: null,
      density: 8.908,
      discovered_by: 'Axel Fredrik Cronstedt',
      melt: 1728,
      molar_heat: 26.07,
      named_by: null,
      number: 28,
      period: 4,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Nickel',
      spectral_img: null,
      summary:
        'Nickel is a chemical element with symbol Ni and atomic number 28. It is a silvery-white lustrous metal with a slight golden tinge. Nickel belongs to the transition metals and is hard and ductile.',
      symbol: 'Ni',
      xpos: 10,
      ypos: 4,
      shells: [2, 8, 16, 2],
    },
    {
      name: '29',
      appearance: 'red-orange metallic luster',
      atomic_mass: 63.5463,
      boil: 2835,
      category: 'emtpy_state',
      color: null,
      density: 8.96,
      discovered_by: 'Middle East',
      melt: 1357.77,
      molar_heat: 24.44,
      named_by: null,
      number: 29,
      period: 4,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Copper',
      spectral_img: null,
      summary:
        'Copper is a chemical element with symbol Cu (from Latin:cuprum) and atomic number 29. It is a soft, malleable and ductile metal with very high thermal and electrical conductivity. A freshly exposed surface of pure copper has a reddish-orange color.',
      symbol: 'Cu',
      xpos: 11,
      ypos: 4,
      shells: [2, 8, 18, 1],
    },
    {
      name: '30',
      appearance: 'silver-gray',
      atomic_mass: 65.382,
      boil: 1180,
      category: 'emtpy_state',
      color: null,
      density: 7.14,
      discovered_by: 'India',
      melt: 692.68,
      molar_heat: 25.47,
      named_by: null,
      number: 30,
      period: 4,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Zinc',
      spectral_img: null,
      summary:
        'Zinc, in commerce also spelter, is a chemical element with symbol Zn and atomic number 30. It is the first element of group 12 of the periodic table. In some respects zinc is chemically similar to magnesium:its ion is of similar size and its only common oxidation state is +2.',
      symbol: 'Zn',
      xpos: 12,
      ypos: 4,
      shells: [2, 8, 18, 2],
    },
    {
      name: '31',
      appearance: 'silver-white',
      atomic_mass: 69.7231,
      boil: 2673,
      category: 'emtpy_state',
      color: null,
      density: 5.91,
      discovered_by: 'Lecoq de Boisbaudran',
      melt: 302.9146,
      molar_heat: 25.86,
      named_by: null,
      number: 31,
      period: 4,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Gallium',
      spectral_img: null,
      summary:
        'Gallium is a chemical element with symbol Ga and atomic number 31. Elemental gallium does not occur in free form in nature, but as the gallium(III) compounds that are in trace amounts in zinc ores and in bauxite. Gallium is a soft, silvery metal, and elemental gallium is a brittle solid at low temperatures, and melts at 29.76 \u00b0C (85.57 \u00b0F) (slightly above room temperature).',
      symbol: 'Ga',
      xpos: 13,
      ypos: 4,
      shells: [2, 8, 18, 3],
    },
    {
      name: '',
      appearance: 'grayish-white',
      atomic_mass: 72.6308,
      boil: 3106,
      category: 'emtpy_state',
      color: null,
      density: 5.323,
      discovered_by: 'Clemens Winkler',
      melt: 1211.4,
      molar_heat: 23.222,
      named_by: null,
      number: 32,
      period: 4,
      phase: 'Solid',
      source: 'https://en.wikipedia.org/wiki/Germanium',
      spectral_img: null,
      summary:
        'Germanium is a chemical element with symbol Ge and atomic number 32. It is a lustrous, hard, grayish-white metalloid in the carbon group, chemically similar to its group neighbors tin and silicon. Purified germanium is a semiconductor, with an appearance most similar to elemental silicon.',
      symbol: '',
      xpos: 14,
      ypos: 4,
      shells: [2, 8, 18, 4],
    },
  ],
};
